import {
  FETCH_HANDOVER,
  FETCH_HANDOVER_SUCCESS,
  FETCH_HANDOVER_FAILURE,
} from "./constants";

const initialState = {
  isFetching: false,
  // Per-resident digest rows: { resident: {uuid,name},
  //   flagged_observations: [...], critical_alerts: [...] }
  residents: null,
  fetchedAt: null,
  error: null,
};

const HandoverReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HANDOVER:
      return { ...state, isFetching: true, error: null };
    case FETCH_HANDOVER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        residents: action.payload?.residents ?? [],
        fetchedAt: action.payload?.fetchedAt ?? null,
      };
    case FETCH_HANDOVER_FAILURE:
      return { ...state, isFetching: false, error: true };
    default:
      return state;
  }
};

export default HandoverReducer;
